(function ($) {
    $(window).load(function () {
        /**
         * tile questions
         */
        $('.collapse_container .contenu_collapse').hide();

        $('.collapse_container').each(function () {
            $(this).find('.wrapper > .texte').click(function () {
                $('.collapse_container.active').not($(this).closest('.collapse_container')).removeClass('active').find('.contenu_collapse').slideUp('fast');
                $(this).closest('.collapse_container').toggleClass('active').find('.contenu_collapse').slideToggle('fast');
            });
        });
    });
})(jQuery);

(function ($) {
    $(window).on('load', function () {
        $('.catalogue_filters_collapse .contenu_collapse').not('.catalogue_filters_collapse.active .contenu_collapse').hide();
        $('.catalogue_filters_collapse').each(function () {
            $(this).find('.wrapper > .texte').click(function () {
                $(this).closest('.catalogue_filters_collapse').toggleClass('active').find('.contenu_collapse').slideToggle('fast');
            });
        });
    });
})(jQuery);